import { axiosInstance as request } from '@/api/rest.service'

export const api = '/to-dos/boards'
export const getBoards = () => request.get(api)
export const newBoard = payload => request.post(api, payload)
export const updateBoard = (id, payload) => request.put(api + `/${id}`, payload)
export const getDeleteConfirm = id => request.get(api + `/${id}/delete-confirmation`)
export const deleteBoard = id => request.delete(api + `/${id}`)
